module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attach-product-feature",
    class: [_vm.demo.orientation == 'right' ? 'shift-right' : 'shift-left']
  }, [_c('img', {
    staticClass: "product-item-image-overlay",
    attrs: {
      "src": require("../../assets/iphone-7-white.png")
    }
  }), _vm._v(" "), _c('video', {
    staticClass: "attach-video-holder",
    attrs: {
      "src": _vm.demo.videoSrc,
      "muted": "",
      "playsinline": "",
      "autoplay": "",
      "loop": ""
    },
    domProps: {
      "muted": true
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ea0a32a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/AttachVerticalHeaderComponent/PhoneAndVideoComponent.vue
// module id = 484
// module chunks = 0